export default __webpack_public_path__ + "static/media/house-6.c12d651c.jpg";